import cn from 'classnames';
import { isSameDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useTranslation } from 'react-i18next';
import type { TimeGridCalendarMode } from '../types';
import { DaylightSavingTimeIndicator } from './daylight-saving-time-indicator';
import styles from './header.module.css';
import { useDaylightSavingTransitionTooltip } from './hooks';
import { TimezonesWithTooltip } from './timezones-with-tooltip';

type P = {
  days: Date[];
  gmtOffsetReferenceDate: Date;
  mode: TimeGridCalendarMode;
  orderedTimezones: string[];
  primaryTimezone: string;
  scrollbarWidth: number;
};

const Header = ({ days, gmtOffsetReferenceDate, mode, orderedTimezones, primaryTimezone, scrollbarWidth }: P) => {
  const { t } = useTranslation(['translationReactComponents']);
  const getDaylightSavingTransitionTooltip = useDaylightSavingTransitionTooltip(primaryTimezone);

  return (
    <div className={styles.header} style={{ paddingRight: `${scrollbarWidth}px` }}>
      <TimezonesWithTooltip gmtOffsetReferenceDate={gmtOffsetReferenceDate} orderedTimezones={orderedTimezones} />
      <div
        className={cn(styles.title, styles['header-grid'], {
          [styles['header-day-grid'] ?? '']: mode === 'day',
          [styles['header-week-grid'] ?? '']: mode === 'week',
        })}
      >
        {days.map((day) => {
          const tooltip = getDaylightSavingTransitionTooltip(day);

          return (
            <div
              className={cn(styles['title-inner'], {
                [styles['current-day'] ?? '']: isSameDay(day, toZonedTime(new Date(), primaryTimezone)),
              })}
              key={day.toISOString()}
            >
              {t('dateFormats.dayNumberShortDay', { date: day })}
              {tooltip ? <DaylightSavingTimeIndicator tooltip={tooltip} /> : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Header;
